import { render } from "./Visit.vue?vue&type=template&id=4067664e&scoped=true"
import script from "./Visit.vue?vue&type=script&lang=js"
export * from "./Visit.vue?vue&type=script&lang=js"

import "./Visit.vue?vue&type=style&index=0&id=4067664e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4067664e"

export default script